import sidebar from "./sidebar.json";
import profile from "./profile.json";
import error from "./error.json";
import coupon from "./coupon.json";
import topup from "./topup.json";
import invoice from "./invoice.json";
import common from "./common.json";
import exportList from "./exportList.json";
import operation from "./operation.json";
import operateRecord from "./operateRecord.json";
import consumption from "./consumption.json";
import center from "./center.json";
import notification from "./notification.json";
import permission from "./permission.json";
import childManager from "./childManager.json";
import desktop from "./desktop.json";

export const zhJson = {
  sidebar,
  profile,
  error,
  coupon,
  topup,
  invoice,
  common,
  exportList,
  operation,
  operateRecord,
  consumption,
  center,
  notification,
  permission,
  childManager,
  desktop,
};
